/**
 * Arco Design 主题配置入口
 * 替代原有的 MUI ThemeProvider
 */

import PropTypes from "prop-types";
import { useMemo } from "react";
import { ConfigProvider } from "@arco-design/web-react";
import zhCN from "@arco-design/web-react/es/locale/zh-CN";
import enUS from "@arco-design/web-react/es/locale/en-US";

// 主题配置
import { arcoTheme, typographyVariables } from "./typography";
import { arcoColorPalette } from "./palette";
// 导入 Arco 样式
import "@arco-design/web-react/dist/css/arco.css";

// 应用项目自定义的 Arco 全局覆盖样式
import "./global.css";
// Arco Message 覆盖（自定义）
import "./message-overrides.css";

// ----------------------------------------------------------------------

/**
 * Arco Design 主题提供者
 * 替代原有的 MUI ThemeProvider
 */
export default function ArcoThemeProvider({ children, locale = "zh-CN" }) {
    // 语言配置
    const localeData = locale === "en-US" ? enUS : zhCN;

    /**
     * 方案二：把主题（字号/行高/字体等）生成的 CSS Variables 注入到页面。
     *
     * 目的：让 "token（ConfigProvider）" 和 "全局 CSS（global.css 里用到的 var(--xxx)）" 共用同一份数据源。
     *
     * 注意：global.css 仍然保留 reset 和 Arco 覆盖样式；但 :root 的字体/字号变量定义不再在 global.css 里维护。
     */
    const typographyCssVariables = useMemo(() => typographyVariables, []);

    // Arco 主题配置
    const theme = useMemo(() => ({
        // 主题 token 配置
        token: {
            // // 颜色配置
            // colorPrimary: arcoColorPalette.primary,
            // colorSuccess: arcoColorPalette.success,
            // colorWarning: arcoColorPalette.warning,
            // colorError: arcoColorPalette.danger,
            // colorInfo: arcoColorPalette.info,
            
            // // 文本颜色
            // colorTextBase: arcoColorPalette.textPrimary,
            // colorTextSecondary: arcoColorPalette.textSecondary,
            
            // // 背景颜色
            // colorBgContainer: arcoColorPalette.bgWhite,
            // colorBgLayout: arcoColorPalette.bgGray,
            
            // 边框
            // colorBorder: arcoColorPalette.border,
            
            // 圆角
            // borderRadius: 8,
            
            // 字体
            fontFamily: arcoTheme.fontFamily,
            // fontSize: arcoTheme.fontSize.body1,
            
            // 阴影（可选）
            // boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
        },
    }), []);

    // 组件配置
    const componentConfig = useMemo(() => ({
        // Button: {
        //     // Button 组件的默认配置
        //     // style: {
        //     //     borderRadius: 8,
        //     // },
        // },
        // Input: {
        //     // Input 组件的默认配置
        //     style: {
        //         borderRadius: 8,
        //     },
        // },
        // Select: {
        //     // Select 组件的默认配置
        //     style: {
        //         borderRadius: 8,
        //     },
        // },
        // Modal: {
        //     // Modal 组件的默认配置
        //     style: {
        //         borderRadius: 8,
        //     },
        // },
    }), []);

    return (
        <>
            {/* 注入 CSS Variables（:root { --font-size-xxx: ... }） */}
            <style data-theme="arco-typography-variables">{typographyCssVariables}</style>
            <ConfigProvider
                theme={theme}
                componentConfig={componentConfig}
                locale={localeData}
            >
                {children}
            </ConfigProvider>
        </>
    );
}

ArcoThemeProvider.propTypes = {
    children: PropTypes.node,
    locale: PropTypes.oneOf(["zh-CN", "en-US"]),
};

